const THREAD_FIELDS = ['reference', 'customer_name', 'delivery_address', 'company_name'];

// El listado HTTP se pide una vez al abrir el panel; el inbox lo mantiene al día: pisa el
// badge de los hilos listados y agrega los que solo él conoce (el primer mensaje llegó
// después de pedir el listado).
export function mergeInboxThreads(threads, inbox) {
  const listed = threads || [];
  if (!inbox) {
    return listed;
  }

  const merged = listed.map((thread) => {
    const live = inbox[thread.pre_package_id];
    return live ? { ...thread, badge: live.badge } : thread;
  });

  const listedIds = new Set(listed.map((thread) => thread.pre_package_id));
  Object.keys(inbox)
    .filter((id) => !listedIds.has(id))
    .forEach((id) => {
      const live = inbox[id];
      const extra = { pre_package_id: id, badge: live.badge };
      THREAD_FIELDS.forEach((field) => { extra[field] = live[field]; });
      merged.push(extra);
    });

  return merged;
}

export function totalUnread(inbox) {
  return Object.values(inbox || {}).reduce((sum, thread) => sum + (thread.badge || 0), 0);
}
